// import NormalizeWheel from 'normalize-wheel'
import { gsap } from "gsap";
import morphdom from 'morphdom';

import Modal from './components/Modal'
import Navigation from './components/Navigation'
import Analytics from './components/Analytics'
import Livewire from './components/Livewire'
import ResponsiveImages from './components/ResponsiveImages'
import BalanceText from './components/BalanceText'

/* Pages based on views/templates */
import Home from './pages/Home'
import Default from './pages/Default'
import Contact from './pages/Contact'
import Journal from './pages/Journal'
import Projects from './pages/Projects'

import { get } from './utils/ajax'
import { setFocusRing } from './utils/setFocusRing'
import { setDevice } from './utils/setDevice'
import { setCurrentTime } from './utils/setCurrentTime'
import { setCurrentTemp } from './utils/setCurrentTemp'
import { getAddress, getCurrentUrl, isVisible } from './helpers';

class App {
  constructor () {
    this.content = document.querySelector('#main')
    this.menuEl  = document.querySelector('.c-menu-overlay [data-scrollable]')
    this.slug = this.content.dataset.slug
    this.eventsEnabled = true
    this.siteInitialised = false

    this.template = document.querySelector('[data-template]').getAttribute('data-template')

    this.scrollHistory = {
      positions: [],
      lastElementClicked: '',
      scrollToSavedPosition: false
    }

    this.currentTime = new setCurrentTime()
    this.currentTemp = new setCurrentTemp()

    this.keycode = []

    setFocusRing()
    setDevice()

    this.createComponents()
    this.createPages()

    this.addEventListeners()

    this.update()

    document.documentElement.classList.remove('js-loading');
    document.documentElement.classList.add('js-loaded');

  }

  createComponents () {
    this.navigationPrimary = new Navigation({
      classes: {
        linksActive: 'c-nav-primary__item--active'
      },
      element: '.c-nav-primary',
      elements: {
        items: '.c-nav-primary__item',
        links: '.c-nav-primary__item a',
      }
    })

    this.navigationSecondary = new Navigation({
      classes: {
        linksActive: 'c-nav-secondary__item--active'
      },
      element: '.c-nav-secondary',
      elements: {
        items: '.c-nav-secondary__item',
        links: '.c-nav-secondary__item a',
      }
    })

    this.menu = new Modal({
      template: this.template,
      target: 'modal'
    })

    this.analytics = new Analytics()
    this.livewire = new Livewire()
    this.responsiveImages = new ResponsiveImages()
    this.balanceText = new BalanceText()
  }

  createPages () {
    this.content = document.querySelector('#main')
    this.slug = this.content.dataset.slug || window.location.pathname

    this.pages = new Map()

    this.pages.set('/', new Home())
    this.pages.set('/default', new Default())
    // this.pages.set('about', new About())
    this.pages.set('/contact', new Contact())
    this.pages.set('/journal', new Journal())
    this.pages.set('/projects', new Projects())
    // this.pages.set('/projects/*', new Projects())


    if (this.slug.indexOf('/projects') > -1 ) {
      this.page = this.pages.get('/projects')
    } else if (this.slug.indexOf('/journal') > -1 ) {
      this.page = this.pages.get('/journal')
    } else {
      this.page = this.pages.get(this.slug) || this.pages.get('/default')
    }

    this.page.create(false)
    this.page.show(0, true)


    console.log('this.page.show;', this.page.show)
    console.log('this.content;', this.content)
    console.log('this.slug;', this.slug)
    console.log('this.page;', this.page)

    // if (this.navigation) {
    //   this.navigation.show(this.slug)
    // }

    this.addLinkListeners()

    /*
     * Header reveal on initial site load
     *
     */
    if (!this.siteInitialised) {
      this.tl = new gsap.timeline()
      this.headerContainer = document.querySelector('.c-header__nav')
      this.headerMiddleNav = document.querySelector('.c-nav-secondary')
      this.headerNavs = document.querySelector('.c-header').querySelectorAll('[data-reveal]')

      if ( isVisible(this.headerMiddleNav)) {
          this.tl
          .fromTo(this.headerContainer, 1.5, {
            yPercent: -100,
          },
          {
            yPercent: 0,
            autoAlpha: 1,
            ease: "power2.Out",
          })
          .fromTo(this.headerNavs, 1.5, {
            yPercent: -100,
            autoAlpha: 0,
          },
          {
            yPercent: 0,
            autoAlpha: 1,
            stagger: .5,
            ease: "power2.Out",
          }, 0)
      } else {
          this.tl
          .fromTo(this.headerContainer, 1, {
            yPercent: -100,
            autoAlpha: 0,
          },
          {
            yPercent: 0,
            autoAlpha: 1,
            ease: "power2.Out",
          })
      }
    }

    this.siteInitialised = true

  }  

  /**
   * Events.
   */
  // onLoaded () {

  //  console.log('this.page', this.page)
  //   this.onResize()

  //   this.page.show()
  // }

  onPopState () {

    // Check if we have a livewire component live on page & RETURN **TEST ONLY**

    this.scrollHistory.scrollToSavedPosition = true

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    /*
     * Update scrollHistory.position based on url (before Popstate)
     */

    let item = this.scrollHistory.positions.find(x => x.id == this.urlPrevious)
    if (item) {
      item.position = window.scrollY
    } else {
      this.scrollHistory.positions.push({id: this.urlPrevious, position: window.scrollY})
    }

    /*
     * load the page
     */

    this.onChange({
      url: window.location.pathname,
      push: false,
      // template: document.querySelector('[data-template]').getAttribute('data-template')
    })


    if (this.page && this.page.onPopState) {
      this.page.onPopState(event)
    }
  }

  onChange ({ callback = () => {}, push = true, url = null }) {
    if (this.isLoading || this.url === url) {
      return
    }

    this.urlPrevious = this.url ? window.location.hostname + this.url : ''
    this.url = url

    this.isLoading = true

    // save the hash from the current event for the onRequest
    this.scrollTo = event.target.hash ? { hash: event.target.hash} : { hash: undefined}

    if (this.responsiveImages) {
      this.responsiveImages.cleanup()
    }

    if (this.balanceText) {
      this.balanceText.cleanup()
    }    

    if (this.livewire) {
      this.livewire.cacheLivewireComponents()
    }

    if (this.menu) {
      this.menu.hide()
    }

    this.page.animateOut()
    this.currentTime.clear()

    get(url).then(response => {
      this.onRequest({
        callback,
        push,
        response,
        url
      })
    }).catch(response => {
      this.onRequest({
        callback,
        push,
        response,
        url: '/'
      })
    })
  }

  async onRequest ({ callback, push, response, url }) {
    
    if (this.cursor) {
      this.cursor.onNavigationStart()
    }

    if (this.navigationPrimary) {
      this.navigationPrimary.onNavigationStart()
    }

    if (this.navigationSecondary) {
      this.navigationSecondary.onNavigationStart()
    }

    this.isLoading = false
    this.eventsEnabled = true

    const html = document.createElement('div')

    html.innerHTML = response

    const content = html.querySelector('#main')
    const menu = html.querySelector('.c-menu-overlay [data-scrollable]')

    if (this.page) {
      await this.page.hide()
    }

    this.content.innerHTML = content.innerHTML
    this.content.dataset.slug = content.dataset.slug
    this.content.dataset.template = content.dataset.template
    document.body.dataset.template = content.dataset.template


    console.log(this.menuEl, menu)
    
    morphdom(this.menuEl, menu)

    const slug = content.dataset.slug
    const page = this.pages.get(slug) || this.pages.get('/default')

    page.create()

    this.calcScrollToPos()

    this.slug = slug

    this.page = page
    // this.page.setScrollPos(this.scrollTo, this.scrollHistory)
    this.page.show()


    if (this.responsiveImages) {
      this.responsiveImages.create()
    }

    if (this.balanceText) {
      this.balanceText.create()
    }    

    if (this.livewire) {
      this.livewire.refreshLivewireComponents()
    }

    if (this.navigationPrimary) {
      this.navigationPrimary.onNavigationEnd(this.slug)
    }

    if (this.navigationSecondary) {
      this.navigationSecondary.onNavigationEnd(this.slug)
    }


    document.title = html.querySelector('title').textContent

    if (push) {
      window.history.pushState({}, document.title, url)
    }

    callback()

    this.currentTime.start()
    this.analytics.update()
    this.addLinkListeners()

  }

  onTouchDown (event) {
    if (!this.eventsEnabled) return

    if (this.page && this.page.onTouchDown) {
      this.page.onTouchDown(event)
    }

    if (this.menu && this.menu.onTouchDown) {
      this.menu.onTouchDown(event)
    }

  }

  onTouchMove (event) {
    if (!this.eventsEnabled) return

    if (this.page && this.page.onTouchDown) {
      this.page.onTouchMove(event)
    }
  }

  onTouchUp (event) {
    if (!this.eventsEnabled) return

    if (this.page && this.page.onTouchDown) {
      this.page.onTouchUp(event)
    }
  }

  onKeyDown (event) {
    if (!this.eventsEnabled) return
    //* Command Key Pressed *//
    event.ctrlKey == true ? this.keycode.ctrl = 'active' : this.keycode.ctrl = ''
    event.metaKey == true ? this.keycode.meta = 'active' : this.keycode.meta = ''
    event.altKey == true ? this.keycode.alt = 'active' : this.keycode.alt = ''
    // console.log('event.key', event.key, this.keycode)

    if (this.page && this.page.onKeyDown) {
      this.page.onKeyDown(event)
    }
    
    if (this.menuModal && this.menuModal.onKeyDown) {
      this.menuModal.onKeyDown(event)
    }

  }

  onKeyUp (event) {
    /* reset the keycode state */
    this.keycode = []
  }

  onBlur (event) {
    /* reset the keycode state */
    this.keycode = []
  }    

  onWheel (event) {
    // const normalizedWheel = NormalizeWheel(event)

    // if (this.page && this.page.onWheel) {
    //   this.page.onWheel(normalizedWheel)
    // }
  }

  onResize () {
    if (this.page && this.page.onResize) {
      this.page.onResize()
    }

    // window.requestAnimationFrame(() => {
    //   if (this.canvas && this.canvas.onResize) {
    //     this.canvas.onResize()
    //   }
    // })
  }

  onLivewireUpdated () {
    this.addLinkListeners()
  }


  /***
   * Calculations
   */
   calcScrollToPos (timing = 0) {
    // if a scrollTo hash exists from the onChange,
    // store the values and scroll to the hash,
    // otherwise, reset the scrollTo position on page change
    // to the top of the page.
    if (this.scrollTo.hash) {
      this.scrollTo = {
        hash: this.scrollTo.hash,
        target: document.querySelector(`${this.scrollTo.hash}`)
      }
      if (this.scrollTo.target)  {
        this.scrollTo.targetHeight = this.scrollTo.target.offsetHeight;
        this.scrollTo.targetMargin = parseInt(`${window.getComputedStyle(this.scrollTo.target).marginTop}`, 10); 
        this.scrollTo.offsetY = ((window.innerHeight - this.scrollTo.targetHeight) / 2) * 1;
        this.scrollTo.y = this.scrollTo.hash

        // if targetHeight > window.innerHeight; offset marginTop of target instead
        if (this.scrollTo.targetHeight > window.innerHeight) {
          this.scrollTo.offsetY = this.scrollTo.targetMargin;
        }
      }
    } else {
      this.scrollTo.y = 0
      this.scrollTo.offsetY = 0
    }

    // if (samePageWithHash) {
      this.page.setScrollPos(this.scrollTo, this.scrollHistory, timing)
    // }
   }

  /***
   * Loop.
   */
  update () {
    if (this.page && this.page.update) {
      this.page.update()
    }

    // if (this.canvas && this.canvas.update) {
    //   this.canvas.update(this.page.scroll)
    // }

    this.frame = window.requestAnimationFrame(this.update.bind(this))
  }

  /***
   * Listeners.
   */
  addEventListeners () {
    window.addEventListener('popstate', this.onPopState.bind(this))
    // window.addEventListener('mousewheel', this.onWheel.bind(this))

    window.addEventListener('mousedown', this.onTouchDown.bind(this))
    window.addEventListener('mousemove', this.onTouchMove.bind(this))
    window.addEventListener('mouseup', this.onTouchUp.bind(this))

    // window.addEventListener('touchstart', this.onTouchDown.bind(this))
    // window.addEventListener('touchmove', this.onTouchMove.bind(this))
    // window.addEventListener('touchend', this.onTouchUp.bind(this))

    window.addEventListener('keydown', this.onKeyDown.bind(this))
    window.addEventListener('keyup', this.onKeyUp.bind(this))
    window.addEventListener('blur', this.onBlur.bind(this))

    window.addEventListener('resize', this.onResize.bind(this))

    window.addEventListener('updated', this.onLivewireUpdated.bind(this))

    /* livewire pagination */
    window.addEventListener('projects-paginated', this.addLinkListeners.bind(this))

    window.addEventListener('articles-paginated', this.addLinkListeners.bind(this))

    


  }

  addLinkListeners () {
    const links = document.querySelectorAll('a')

    links.forEach(link => {
      const isLocal = link.href.indexOf(window.location.origin) > -1

      const isNotEmail = link.href.indexOf('mailto') === -1
      const isNotPhone = link.href.indexOf('tel') === -1


      if (isLocal) {
        link.onclick = event => {
          this.onClick(link)
        }
      } else if (isNotEmail && isNotPhone) {
        link.rel = 'noopener'
        link.target = '_blank'
      }
    })

  }

  onClick (link) {

    if (this.keycode.ctrl == 'active' || 
        this.keycode.meta == 'active' || 
        this.keycode.alt == 'active') 
    {
      window.open(link.href, "_blank");
      return
    }

    let item = this.scrollHistory.positions.find(x => x.id == window.location.href)
    if (item) {
      item.position = window.scrollY
    } else {
      this.scrollHistory.positions.push({id: window.location.href, position: window.scrollY})
    }

    this.scrollHistory.lastElementClicked = event.target
    this.scrollHistory.scrollToSavedPosition = false
   
    const samePage = getAddress(event.target) == getCurrentUrl() || getAddress(event.target) == '' ? true : false
    // const samePageWithHash = getAddress(event.target) == getCurrentUrl() || getAddress(event.target) == '' ? true : false
    const samePageWithHash = getAddress(event.target) == '' ? true : false
    const isHash = event.target.hash ? true : false
    const isDownload = event.target.hasAttribute('download')

    if (isDownload) {
      return
    }

    event.preventDefault()

    if (isHash) {
      // save the hash from the current event for the onRequest
      this.scrollTo = { hash: event.target.hash }
    }

    if (samePage) {
      if (isHash) {
        this.calcScrollToPos(1)
      } 
      if (this.menu) {
        this.menu.hide()
      }
      return
    }

    this.onChange({
      url: link.href
    })

    this.eventsEnabled = false

  }

}

new App()
